export default __webpack_public_path__ + "f8f181943c891848452fe1bef228cf6e.svg";